import React, { createContext } from 'react'
import { DocumentsStore } from '../Boat/Details/Documentation/DocumentsStore'

export const FilesContext = createContext<{ store: DocumentsStore }>(null)

interface Props {
  store: DocumentsStore
  children: React.ReactNode
}

export const FilesContextProvider: React.FC<Props> = ({ store, children }) => {
  return <FilesContext.Provider value={{ store }}>{children}</FilesContext.Provider>
}
